import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  generalMessages: [],
  getGeneralMessagesStatus: IDLE,

  assignGeneralMessageStatus: IDLE,

  deleteGeneralMessageStatus: IDLE
};

const generalMessagesSlice = createSlice({
  name: 'generalMessages',
  initialState,
  reducers: {
    getGeneralMessages(state) {
      state.getGeneralMessagesStatus = LOADING;
    },
    getGeneralMessagesSucceeded(state, action) {
      state.generalMessages = action.payload;
      state.getGeneralMessagesStatus = SUCCEEDED;
    },
    getGeneralMessagesFailed(state) {
      state.getGeneralMessagesStatus = FAILED;
    },

    //* action payload expects { message, entityType, entityId, renderSuccessNotification, navigate, callback }
    assignGeneralMessage(state) {
      state.assignGeneralMessageStatus = LOADING;
    },
    assignGeneralMessageSucceeded(state) {
      state.assignGeneralMessageStatus = SUCCEEDED;
    },
    assignGeneralMessageFailed(state) {
      state.assignGeneralMessageStatus = FAILED;
    },

    //* action payload expects { messageId, callback }
    deleteGeneralMessage(state) {
      state.deleteGeneralMessageStatus = LOADING;
    },
    deleteGeneralMessageSucceeded(state) {
      state.deleteGeneralMessageStatus = SUCCEEDED;
    },
    deleteGeneralMessageFailed(state) {
      state.deleteGeneralMessageStatus = FAILED;
    }
  }
});

export const {
  getGeneralMessages,
  getGeneralMessagesSucceeded,
  getGeneralMessagesFailed,
  assignGeneralMessage,
  assignGeneralMessageSucceeded,
  assignGeneralMessageFailed,
  deleteGeneralMessage,
  deleteGeneralMessageSucceeded,
  deleteGeneralMessageFailed
} = generalMessagesSlice.actions;

export default generalMessagesSlice.reducer;
